"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bem_cn_1 = require("bem-cn");

exports.UIKIT = 'emankit';
exports.block = bem_cn_1.setup({
  ns: exports.UIKIT + "__",
  mod: '--'
});